"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableReact = exports.Table = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Spinner = _interopRequireDefault(require("../spinner/Spinner"));
var _Summary = require("../table-summary/Summary");
var _Feedback = require("../feedback/Feedback");
var _store = require("../../store");
var _constants = require("../../store/constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TableReact = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TableReact, _React$Component);
  var _super = _createSuper(TableReact);
  function TableReact() {
    var _this;
    (0, _classCallCheck2.default)(this, TableReact);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchMoreRecords", function () {
      _this.props.fireSearch(_constants.MORE_PENDING);
      _this.props.fireSearch(_constants.MORE_COMPLETE);
    });
    return _this;
  }
  (0, _createClass2.default)(TableReact, [{
    key: "continueToPI1",
    value: function continueToPI1(id) {
      var table = this.props.table;
      if (table.resultType === _constants.FUZZY) {
        var recordsMap = table.recordsMap[id];
        var payLoad = {
          PF_PROVIDER_CLIENT_ID: id,
          PF_PROVIDER_FUZZY_SCORE: recordsMap.score
        };
        (0, _constants.trackEventWithHeap)(_constants.PF_PROVIDER_FUZZY_CONVERSION_EVENT, payLoad);
      }
      var destinationURL = "".concat(window.location.origin, "/patientsolutions/app/check-your-rate?user=applicant&clientid=").concat(id);
      window.location.href = destinationURL;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var table = this.props.table;
      var renderRecords = function renderRecords(tableProp) {
        return tableProp.records.map(function (val, index) {
          var clientId = val.id ? val.id : val.client_id ? val.client_id : '';
          var clientFL = (val.client_first_name ? val.client_first_name : '') + ' ' + (val.client_last_name ? val.client_last_name : '');
          return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
            key: "record-".concat(index)
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "select-provider-content-desktop provider-record"
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "client-info"
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "client-name"
          }, val.client_name, " ", /*#__PURE__*/_react.default.createElement("div", null, clientFL === ' ' ? '' : '(' + clientFL + ')')), /*#__PURE__*/_react.default.createElement("div", {
            className: "client-address"
          }, val.address), /*#__PURE__*/_react.default.createElement("div", {
            className: "client-city"
          }, /*#__PURE__*/_react.default.createElement("div", null, val.city, ","), /*#__PURE__*/_react.default.createElement("div", null, val.state, " ", val.zip))), /*#__PURE__*/_react.default.createElement("div", {
            onClick: function onClick() {
              return _this2.continueToPI1(clientId);
            },
            className: "select-provider"
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "select-provider-selector-desktop"
          }, "Select"))), /*#__PURE__*/_react.default.createElement("div", {
            onClick: function onClick() {
              return _this2.continueToPI1(clientId);
            },
            className: "select-provider-content-mobile provider-record"
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "client-info"
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "client-name"
          }, val.client_name, " ", clientFL === ' ' ? '' : '(' + clientFL + ')'), /*#__PURE__*/_react.default.createElement("div", {
            className: "client-address"
          }, val.address), /*#__PURE__*/_react.default.createElement("div", {
            className: "client-city"
          }, val.city, ", ", val.state, " ", val.zip)), /*#__PURE__*/_react.default.createElement("div", {
            className: "select-provider"
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "select-provider-selector-mobile"
          }, /*#__PURE__*/_react.default.createElement("i", {
            className: "arrow-right"
          })))));
        });
      };
      var renderMoreRecordsLinkOrSpinner = function renderMoreRecordsLinkOrSpinner(tableProp) {
        if (tableProp.request === _constants.MORE_PENDING) {
          return /*#__PURE__*/_react.default.createElement(_Spinner.default, null);
        }

        // Use the below to view all the provider lazy loaded 40 at a time
        // const flag = (tableProp && tableProp.totalResultsFromExactSearch && tableProp.records.length < tableProp.totalResultsFromExactSearch) ? true : false;
        // Use the below to view all the provider lazy loaded 40 at a time until 80
        var flag = tableProp && tableProp.totalResultsFromExactSearch > 40 && tableProp.records && tableProp.records.length < 80 && tableProp.records.length >= 40 && tableProp.totalResultsFromExactSearch !== tableProp.records.length;
        var remainingRecords = tableProp.totalResultsFromExactSearch < 80 ? tableProp.totalResultsFromExactSearch - tableProp.records.length : 40;
        return flag ? /*#__PURE__*/_react.default.createElement("div", {
          className: "more-records"
        }, /*#__PURE__*/_react.default.createElement("a", {
          onClick: _this2.fetchMoreRecords
        }, "View ", remainingRecords, " more results")) : '';
      };
      var renderLoaderOrRecords = function renderLoaderOrRecords(tableProp) {
        if (tableProp.request === _constants.PENDING) {
          return /*#__PURE__*/_react.default.createElement(_Spinner.default, null);
        }
        var flag = tableProp && tableProp.records && tableProp.records.length > 0 ? true : false;
        var records = flag ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
          className: "table-summary-desktop"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "table-summary-desktop-practice"
        }, "Practice"), /*#__PURE__*/_react.default.createElement("div", {
          className: "table-summary-desktop-location"
        }, "Location"), /*#__PURE__*/_react.default.createElement("div", {
          className: "table-summary-desktop-city"
        }, "City")), /*#__PURE__*/_react.default.createElement("div", {
          className: "results"
        }, renderRecords(tableProp))) : '';
        return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_Summary.TableSummary, null), records, renderMoreRecordsLinkOrSpinner(table));
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "table-results"
      }, renderLoaderOrRecords(table), /*#__PURE__*/_react.default.createElement(_Feedback.Feedback, null));
    }
  }]);
  return TableReact;
}(_react.default.Component);
exports.TableReact = TableReact;
var mapStateToProps = function mapStateToProps(state) {
  return {
    siteInfo: state.siteInfo,
    table: state.table
  };
};
TableReact.propTypes = {
  siteInfo: _propTypes.default.object.isRequired,
  fireSearch: _propTypes.default.func,
  table: _propTypes.default.object
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_objectSpread({}, _store.actions), dispatch);
};
var Table = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TableReact);
exports.Table = Table;
